export const question_one = [{
    question: "Who is a new creation ?",
    options: ["The man in Christ", "The one who goes to church", "The good man", "The man who talks well"],
    correct: "The man in Christ",
    id: 1
  },
  {
    question: "Does the new creation have a past ?",
    options: ["No", "Not sure", "Yes he does", "None of the above"],
    correct: "No",
    id: 2
  },
  {
    question: "We are created unto ?",
    options: ["Good works", "Academic works", "Fortunate works", "None of the above"],
    correct: "Good works",
    id: 3
  },
  {
    question: "To be born of God is to be ...... ?",
    options: ["born of man's will", "born of His word", "a worker in his house", "interested in godly activities"],
    correct: "born of His word",
    id: 4
  },
  {
    question: "According to the parable of the sower, the seed is ....... ?",
    options: ["the starting point", "the heart of man", "the Word", "for the ground"],
    correct: "the Word",
    id: 5
  },
  {
    question: "Salvation is by ?",
    options: ["Grace through grace", "Grace through miracles", "Works", "Grace through faith"],
    correct: "Grace through faith",
    id: 6
  },
  {
    question: "We are assured of our salvation through ?",
    options: ["Our Pastors", "Works", "The word and witness of the Spirit", "The word and attending church services"],
    correct: "The word and witness of the Spirit",
    id: 7
  },
  {
    question: "Forgiveness is not for the .......... ?",
    options: ["Sinner", "Woman", "Christian", "Both A and C"],
    correct: "Christian",
    id: 8
  },
  {
    question: "The remission of sins is for the ........ ?",
    options: ["the Christian", "the good man", "the bad Christian", "the unbeliever"],
    correct: "the unbeliever",
    id: 9
  },
  {
    question: "When a Christian does something wrong, he needs to ......... ?",
    options: ["cry for his sins", "be sorry for his sins", "ask for forgiveness from God", "feels condemned"],
    correct: "ask for forgiveness from God",
    id: 10
  },
  {
    question: "Man is ....... ?",
    options: ["a human being", "a soul", "a spirit", "a body"],
    correct: "a spirit",
    id: 11
  },
  {
    question: "The body is the man's ........... ?",
    options: ["house", "life", "being", "none of the above"],
    correct: "house",
    id: 12
  },
  {
    question: "Decisions are taken in ........ ?",
    options: ["the house", "the spirit", "the soul"],
    correct: "the soul",
    id: 13
  },
  {
    question: "The spirit man got ?",
    options: ["amnesty", "beaten", "saved", "none of the above"],
    correct: "saved",
    id: 14
  },
  {
    question: "The body needs food to grow as the spirit needs ........ to grow ?",
    options: ["joy", "the peace of God", "rich food", "the Word of God"],
    correct: "the Word of God",
    id: 15
  },
  {
    question: "The Holy Spirit bears fruits according to Galatians 5 vrs 22-23 ?",
    options: ["Yes", "No", "Not sure", "None of the above"],
    correct: "No",
    id: 16
  },
  {
    question: "Faithfulness is one of the fruits of the recreated human's spirit.",
    options: ["False", "True", "May be", "All of the above"],
    correct: "True",
    id: 17
  },
  {
    question: "We are to renew ?",
    options: ["our spirits", "our banks", "our minds", "All of the above"],
    correct: "our minds",
    id: 18
  },
  {
    question: "The Word is the only necessary ingredient for the renewing process.",
    options: ["True", "False", "Could be", "None of the above"],
    correct: "True",
    id: 19
  },
  {
    question: "We are to bring our bodies under subjection to ?",
    options: ["the World", "the Word", "the soul", "none of the above"],
    correct: "the Word",
    id: 20
  },
  {
    question: "Doctrine means ?",
    options: ["Message", "Title", "Sermon", "Teaching"],
    correct: "Teaching",
    id: 21
  },
  {
    question: "Being established upon the truth is a ?",
    options: ["Title", "Teaching", "Doctrine", "All of the above"],
    correct: "Doctrine",
    id: 22
  },
  {
    question: "Santification means ?",
    options: ["Without fault", "Without blame", "Without wrong", "Separated unto God"],
    correct: "Separated unto God",
    id: 23
  },
  {
    question: "Laying on of hands is for ?",
    options: ["Fighting", "Gaining more power", "Attacking", "Ordination into ministry"],
    correct: "Ordination into ministry",
    id: 24
  },
  {
    question: "Ressurection from the dead is a ?",
    options: ["Title", "Sermon", "Doctrine", "Foundational Doctrine"],
    correct: "Foundational Doctrine",
    id: 25
  },
  {
    question: "According to Romans 6 vrs 3-5 were baptised into ?",
    options: ["Water", "Fire", "Jesus Christ", "All of the above"],
    correct: "Jesus Christ",
    id: 26
  },
  {
    question: "Baptism in Greek means ?",
    options: ["Sprinkling", "Cleansing", "Immersion", "Washing"],
    correct: "Immersion",
    id: 27
  },
  {
    question: "The Greek word for baptism is ?",
    options: ["Baptism", "Bapismms", "Baptizo", "All of the above"],
    correct: "Baptizo",
    id: 28
  },
  {
    question: "Baptism of the Holy Ghost is the ?",
    options: ["New birth", "Old birth", "Faith birth", "None of the above"],
    correct: "New birth",
    id: 29
  },
  {
    question: "When Jesus was nailed on the cross you were ?",
    options: ["Hanged on a tree", "Delivered", "Baptized", "None of the above"],
    correct: "Delivered",
    id: 30
  },
  {
    question: "Righteousness produces ........ and sin produces ....... ?",
    options: ["Faith, Fear", "Grace, Death", "Fear, Faith", "All of the above"],
    correct: "Grace, Death",
    id: 31
  },
  {
    question: "Repantance from ...... works ?",
    options: ["News works", "Old", "Current", "Dead"],
    correct: "Dead",
    id: 32
  },
  {
    question: "Righteousness is the ...... of God ?",
    options: ["Character", "Attitude", "Behaviour", "Nature"],
    correct: "Nature",
    id: 33
  },
  {
    question: "The ..... came by Moses but grace and ...... came by Jesus Christ ?",
    options: ["Pentateuch, love", "Law, holiness", "Law, truth", "Law, santification"],
    correct: "Law, truth",
    id: 34
  },
  {
    question: "According to Hebrews 13 vrs 1 a christian is ?",
    options: ["Alive brethren", "Good brethren", "Partakers brethren", "Holy brethren"],
    correct: "Holy brethren",
    id: 35
  },
  {
    question: "According to Romans 5 vrs 17 they which receive abudance of grace and of the gift of rigteousness shall ....... ?",
    options: ["Go to heaven", "Go to paradise", "Reigh in heaven", "Reign in life"],
    correct: "Reign in life",
    id: 36
  },
  {
    question: "Eternal jugment is a ?",
    options: ["Reward", "Warning", "Foundational doctrine", "All of the abovev"],
    correct: "Foundational doctrine",
    id: 37
  },
  {
    question: "This is a foundational doctrine of Christ, faith towards ......... ?",
    options: ["Man", "Life", "God", "All of the above"],
    correct: "God",
    id: 38
  },
  {
    question: "According to Acts 1 vrs 8 the infilling of the Holy Spirit is for ?",
    options: ["Renewal", "Strength", "Witness", "All of the above"],
    correct: "Witness",
    id: 39
  },
  {
    question: 'The purpose of speaking in tongues is to:',
    options: ['Built up your faith', 'To prevent others from hearing us', 'To make us popular in church', 'All of the above'],
    correct: 'Built up your faith',
    id: 40
  },
  {
    question: 'Which of the following is not a ministry gift?',
    options: ['Pastor', 'Bishop', 'Teacher', 'Evangelist'],
    correct: 'Bishop',
    id: 41
  },
  {
    question: 'All these are the synonyms of the Holy Spirit except:',
    options: ['Comforter', 'Counsellor', 'Advocate', 'Prophecy'],
    correct: 'Prophecy',
    id: 42
  },
  {
    question: 'Which of the following is/are a gift(s) of the Holy Spirit?',
    options: [' Word of Wisdom', 'Working of Miracles', 'Word of Knowledge', 'All of the above'],
    correct: 'All of the above',
    id: 43
  },
  {
    question: 'Man has his reasoning faculty in:',
    options: ['His body with its five senses', 'His spirit', 'His body', 'His soul'],
    correct: 'His soul',
    id: 44
  },
  {
    question: 'Gentleness and self-control are classified as:',
    options: ['Gifts of the Holy Spirit', 'Fruits of the recreated human spirit', 'Fruits of the Holy spirit', 'All of the above'],
    correct: 'Fruits of the recreated human spirit',
    id: 45
  },
  {
    question: 'Who is the Holy Spirit?',
    options: ['He is God Himself', 'He is the Comforter', 'He is the third person in Godhead', 'All of the above'],
    correct: 'All of the above',
    id: 46
  },
  {
    question: 'ministry gift is a calling into an office',
    options: ['True', 'False', 'Both a and b', 'None of the above'],
    correct: 'True',
    id: 47
  },
  {
    question: 'every Christian can receive the Holy Spirit.',
    options: ['True', 'False', 'Both a and b', 'None of the above'],
    correct: 'True',
    id: 48
  },
  {
    question: 'Not everyone can receive the Holy Spirit except:',
    options: ['He attends church regularly', 'He is a new creation', 'All of the above'],
    correct: 'He is a new creation',
    id: 49
  },
  {
    question: 'All of these are gifts of the Holy Spirit except',
    options: ['Working of Miracles', 'Healing', 'Gift of Prophecy', 'counsellor'],
    correct: 'counsellor',
    id: 50
  },
  {
    question: 'The Holy Spirit is',
    options: ['Heteros Parakletos', 'Boss of the Godhead', 'A good person', 'The Spirit that proceeds from God'],
    correct: 'The Spirit that proceeds from God',
    id: 51
  },
  {
    question: 'Advocate is a sysnonym for',
    options: ['A Man', 'The Holy Spirit', 'A Pastor', 'All of the above'],
    correct: 'The Holy Spirit',
    id: 52
  },
  {
    question: 'Allos Parakletos is also referred to as:',
    options: ['Strengthener', 'Comforter', 'Standby', 'Intercessor'],
    correct: 'Comforter',
    id: 53
  },
  {
    question: 'We build our faith by;',
    options: ['Going to the market regularly', 'Meditating on the word of God', 'Going to church regularly'],
    correct: 'Meditating on the word of God',
    id: 54
  },
  {
    question: 'Tongues speaking is a must for every;',
    options: ['Christian', 'Natural man', 'Unbeliever', 'All of the above'],
    correct: 'Christian',
    id: 55
  }, {
    question: 'Self-control is the fruit of the recreated Human spirit while Faith is',
    options: ['Gifts from Pastors messages', 'Special anointing', 'Gifts of the Holy Spirit', 'None of the above'],
    correct: 'Gifts of the Holy Spirit',
    id: 56
  },
  {
    question: 'speaking mysteries to God is through.....',
    options: ['Baptism', 'Communion Service', 'Tongues speaking', 'Both a and b'],
    correct: 'Tongues speaking',
    id: 57
  }, {
    question: 'Our life begins to.......God as we pray in tongues',
    options: ['Wrong', 'Glorify', 'Provoke', 'Both a and b'],
    correct: 'Glorify',
    id: 58
  }, {
    question: 'According to Galatians 5:22, Love,Joy,Peace are the fruits of',
    options: ['Pastor', 'Christian', 'Recreated Human Spirit', 'Gifts of the Holy Spirit'],
    correct: 'Recreated Human Spirit',
    id: 59
  },
]